module.exports = __webpack_public_path__ + "img/leavy-default.b5b78318.svg";